'use client';

import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import PlayBurger from '@/components/home/PlayBurger';
import { SectionHeader } from '@/components/ui/Typography';
import ReactPlayer from 'react-player';

type Props = {
  params: { locale: string };
  dictionary: any;
};

const points: { [key: string]: string[] } = {
  de: [
    'Mehr Gäste und mehr Umsatz?',
    'Marketing und eine höhere Sichtbarkeit in den Suchmaschinen?',
    'Eventankündigungen für eine erfolgreiche Veranstaltung?',
    'Mehr Mitarbeiter, die dich und dein Team unterstützen?',
    'Ein Bestellsystem OHNE Umsatzbeteiligung?',
    'Kunden schnell und einfach über Neuigkeiten und Aktionen zu informieren?',
  ],
  en: [
    'More guests and more sales?',
    'Marketing and higher visibility in the search engines?',
    'Event announcements for a successful event?',
    'More employees to support you and and your team?',
    'An ordering system WITHOUT any revenue sharing?',
    'Inform customers quickly and easily about news and promotions?',
  ],
};

const getPoints = (lang: string): string[] => {
  return points[lang] ?? [];
};

export default function VendorInterviewVideoSection({
  params,
  dictionary,
}: Props) {
  const [lang] = params.locale.split('-');

  return (
    <section className="bg-primary-800 py-20">
      <div className="container flex flex-col md:gap-x-10 lg:flex-row">
        <div className="mb-8 flex flex-col justify-center lg:mb-0 lg:w-[40%]">
          <div className="text-center text-lg font-normal text-white lg:text-left">
            Interview
          </div>
          <SectionHeader className="text-center text-white lg:text-left">
            {dictionary.vendor_page.features.video.header_faq}
          </SectionHeader>
          {/* <h3 className="text-h1 font-black text-white">
            </h3> */}
          <h3 className="text-center text-lg text-white lg:text-left">
            Thomas Wos
          </h3>
          {/* <h4 className="text-lg font-thin italic text-white opacity-75">
            {dictionary.vendor_page.guest_satisfaction.sub_head}
          </h4>
          <h3 className="text-h2 font-bold text-white">
            {dictionary.vendor_page.guest_satisfaction.heading}
          </h3> */}
          {/* <div className="mt-5 h-auto w-[200px]">
            <Image
              src={'/vendor/guest-advantage.png'}
              width={150}
              height={80}
              sizes="100vw"
              alt="Order Burger Area"
              className="h-auto w-full rounded-[20px]"
            />
          </div> */}
        </div>
        <div className="mx-auto lg:w-[60%]">
          <div className="w-fit lg:ml-auto">
            <div className="flex w-full items-center justify-center lg:justify-start">
              <div className="relative h-auto w-[280px] pt-[56.25%] sm:w-[500px] md:w-[600px] lg:w-[580px] xl:w-[700px]">
                <ReactPlayer
                  url={'https://youtu.be/I55pzPfQ23k'}
                  height="100%"
                  width="100%"
                  className="absolute left-0 top-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
